import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { MenuItem, Select, ThemeProvider } from "@mui/material";

import BaseGraph from "./BaseGraph";

import { table2Theme } from "../styles/Table2";
import { defaultTheme } from "../styles/Theme";

const records = [
  {
    origin: "Chicago, IL",
    destination: "Springfield, OH",
    "2021": 0,
    "2022": 7,
    "2023": 0,
    "2024": 0,
  },
  {
    origin: "Chicago, IL",
    destination: "Ainsworth, NE",
    "2021": 7045,
    "2022": 46220,
    "2023": 0,
    "2024": 0,
  },
  {
    origin: "Chicago, IL",
    destination: "Chattanooga, TN",
    "2021": 503,
    "2022": 0,
    "2023": 0,
    "2024": 0,
  },
  {
    origin: "Sioux City, IA",
    destination: "Rochester, MN",
    "2021": 0,
    "2022": 64,
    "2023": 1265,
    "2024": 789,
  },
  {
    origin: "Sioux City, IA",
    destination: "Lexington, KY",
    "2021": 45645,
    "2022": 5431,
    "2023": 10000,
    "2024": 8564,
  },
];

const rows = records.reduce((acc: any, row: any) => {
  if (!acc[row.origin]) {
    acc[row.origin] = [];
  }
  acc[row.origin].push(row);
  return acc;
}, {} as any);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LocationQty = () => {
  const infoMessage = (
    <>
      <b>Filter criteria</b>: Customer Name, Modes, Industry, Cities, States
      <br />
      {/* <b>UOM</b>: {uom} */}
    </>
  );

  const body = (
    <ThemeProvider theme={table2Theme}>
      <TableContainer
        // component={Paper}
        style={{ overflowY: "auto" }}
        sx={{ boxShadow: "none" }}
      >
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell style={{ paddingRight: 50, width: 200 }}>
                Origin
                <ThemeProvider theme={defaultTheme}>
                  <Select className="XtremeSmall" value="*" fullWidth />
                </ThemeProvider>
              </TableCell>
              <TableCell style={{ paddingRight: 50, width: 200 }}>
                Destination
                <ThemeProvider theme={defaultTheme}>
                  <Select className="XtremeSmall" value="*" fullWidth />
                </ThemeProvider>
              </TableCell>
              <TableCell>2021</TableCell>

              <TableCell>2022</TableCell>
              <TableCell>2023</TableCell>
              <TableCell>2024</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            id="tablebody"
            style={{ overflowY: "scroll", cursor: "pointer" }}
          >
            {rows &&
              Object.keys(rows).length > 0 &&
              Object.keys(rows).map((key) => (
                <>
                  <TableRow key={key}>
                    <TableCell rowSpan={rows[key].length + 1}>{key}</TableCell>
                  </TableRow>
                  {rows[key].map((row: any) => (
                    <TableRow>
                      <TableCell>{row.destination}</TableCell>
                      <TableCell>{row["2021"]}</TableCell>
                      <TableCell>{row["2022"]}</TableCell>
                      <TableCell>{row["2023"]}</TableCell>
                      <TableCell>{row["2024"]}</TableCell>
                    </TableRow>
                  ))}
                </>
              ))}
            {rows &&
              Object.keys(rows).length > 0 &&
              Object.keys(rows).map((key) => (
                <>
                  <TableRow key={key}>
                    <TableCell rowSpan={rows[key].length + 1}>{key}</TableCell>
                  </TableRow>
                  {rows[key].map((row: any) => (
                    <TableRow>
                      <TableCell>{row.destination}</TableCell>
                      <TableCell>{row["2021"]}</TableCell>
                      <TableCell>{row["2022"]}</TableCell>
                      <TableCell>{row["2023"]}</TableCell>
                      <TableCell>{row["2024"]}</TableCell>
                    </TableRow>
                  ))}
                </>
              ))}
            {rows &&
              Object.keys(rows).length > 0 &&
              Object.keys(rows).map((key) => (
                <>
                  <TableRow key={key}>
                    <TableCell rowSpan={rows[key].length + 1}>{key}</TableCell>
                  </TableRow>
                  {rows[key].map((row: any) => (
                    <TableRow>
                      <TableCell>{row.destination}</TableCell>
                      <TableCell>{row["2021"]}</TableCell>
                      <TableCell>{row["2022"]}</TableCell>
                      <TableCell>{row["2023"]}</TableCell>
                      <TableCell>{row["2024"]}</TableCell>
                    </TableRow>
                  ))}
                </>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );

  const subTitle = (
    <div style={{ display: "flex", alignItems: "flex-start" }}>
      <Select
        className="XtremeSmall"
        value="*"
        fullWidth
        style={{ color: "#595959", fontWeight: 400 }}
      >
        <MenuItem value="*">Monte Vista, CO</MenuItem>
      </Select>
    </div>
  );

  return (
    <BaseGraph
      // loading={loading}
      loading={false}
      title="BY ORIGIN & DESTINATION"
      subTitle={subTitle}
      infoMessage={infoMessage}
      // height={500}
    >
      {body}
    </BaseGraph>
  );
};

export default LocationQty;
